export default {  
  starUserContainerDiv:{
    background: '#fff',
    borderBottom: data => '3px solid ' + data.STdefaultTier,
    padding: '10px 20px',
    display: 'block'
  },
  starUserContainer:{
    display: 'block',
    maxWidth: '1170px',
    margin: '0 auto',
    textAlign: 'right',
    font: '300 14px Roboto, sans-serif'
  },
  stSilverTier: {
    fill: data => data.STsilverTier,
    color: data => data.STsilverTier,
    borderColor: data => data.STsilverTier
  },
  stGoldTier: {
    fill: data => data.STgoldTier,
    color: data => data.STgoldTier,
    borderColor: data => data.STgoldTier
  },
  stBlueTier: {
    fill: data => data.STblueTier,
    color: data => data.STblueTier,
    borderColor: data => data.STblueTier
  },
  stDefault: {
    fill: data => data.STdefaultTier,
    color: data => data.STdefaultTier,
    borderColor: data => data.STdefaultTier,
  },
}